import { Component, Input } from '@angular/core';
import { SellionsEvent } from '../../../modules/calendar/services/events-service/events-service';
import { IClientModel } from '../../../modules/clients/interfaces/i-client-model.interface';
import { IRecipient } from '../../../modules/clients/interfaces/i-recipient.interface';
import { TextServiceProvider } from '../../../modules/core/services/text-service/text-service';

@Component({
  selector: 'sellions-event',
  templateUrl: 'sellions-event.html',
})
export class SellionsEventComponent {
  public event: SellionsEvent;
  public recipient: IRecipient;
  public client: IClientModel;

  constructor(public textService: TextServiceProvider) {}

  public getColorForEventState(state: string): string {
    switch (state) {
      case 'PLANNED':
        return '#ff0000';
      case 'COMPLETED':
        return '#008000';
    }
    return '#00aaff';
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-event/sellions-event.ts